import { PlayCircleIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getPhoneCallRecording } from 'services'

/**
 * Play back a call recording.
 *
 * The audio is fetched only when somebody asks for it, and through the API with their own session
 * rather than from a carrier link. A grid that eagerly loaded every recording would both be slow
 * and quietly hand a page-load's worth of borrower conversations to anyone who opened the screen.
 */
export const RecordingPlayer = ({ phoneCallId }: { phoneCallId: number }) => {
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(false)

  // The object URL holds the audio in memory until it is released.
  useEffect(
    () => () => {
      if (url) URL.revokeObjectURL(url)
    },
    [url],
  )

  const onPlay = async () => {
    setLoading(true)
    try {
      const blob = await getPhoneCallRecording(phoneCallId)
      setUrl(URL.createObjectURL(blob))
    } catch {
      toast.error('That recording could not be played.')
    } finally {
      setLoading(false)
    }
  }

  if (url) return <audio controls autoPlay src={url} className="h-8 max-w-[200px]" />

  return (
    <button
      type="button"
      onClick={onPlay}
      disabled={loading}
      className="flex items-center gap-1 text-shade-blue hover:underline text-[12px] font-semibold disabled:opacity-50"
    >
      <PlayCircleIcon className="w-4 h-4" />
      {loading ? 'Loading' : 'Recording'}
    </button>
  )
}
